module.exports = __webpack_public_path__ + "img/phone-white.b57216fc.svg";